/** Formatage FR des nombres, durées et dates du tableau de pilotage. */

const nf = new Intl.NumberFormat('fr-FR');
const nf1 = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 });

export function num(n: number | null | undefined): string {
  return n === null || n === undefined || Number.isNaN(n) ? '–' : nf.format(Math.round(n));
}

export function dec(n: number | null | undefined, digits = 1): string {
  if (n === null || n === undefined || Number.isNaN(n)) return '–';
  return digits === 1 ? nf1.format(n) : new Intl.NumberFormat('fr-FR', { maximumFractionDigits: digits }).format(n);
}

export function pct(n: number | null | undefined, digits = 1): string {
  return n === null || n === undefined ? '–' : `${dec(n, digits)} %`;
}

/** Nombre compact : 12 400 → « 12,4 k » */
export function compact(n: number | null | undefined): string {
  if (n === null || n === undefined) return '–';
  if (Math.abs(n) >= 1_000_000) return `${nf1.format(n / 1_000_000)} M`;
  if (Math.abs(n) >= 10_000) return `${nf1.format(n / 1000)} k`;
  return nf.format(Math.round(n));
}

export function ms(n: number | null | undefined): string {
  if (n === null || n === undefined) return '–';
  return n >= 1000 ? `${dec(n / 1000, 2)} s` : `${num(n)} ms`;
}

export function bytes(n: number | null | undefined): string {
  if (n === null || n === undefined) return '–';
  if (n >= 1024 ** 3) return `${dec(n / 1024 ** 3)} Go`;
  if (n >= 1024 ** 2) return `${num(n / 1024 ** 2)} Mo`;
  return `${num(n / 1024)} Ko`;
}

export function duration(sec: number | null | undefined): string {
  if (sec === null || sec === undefined) return '–';
  if (sec < 90) return `${Math.round(sec)} s`;
  if (sec < 5400) return `${Math.round(sec / 60)} min`;
  if (sec < 172800) return `${Math.round(sec / 3600)} h`;
  return `${Math.round(sec / 86400)} j`;
}

/** « il y a 3 min » */
export function ago(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '–';
  const s = Math.max(0, (now - new Date(iso).getTime()) / 1000);
  if (s < 45) return "à l'instant";
  return `il y a ${duration(s)}`;
}

export function time(iso: string | null | undefined): string {
  if (!iso) return '–';
  return new Date(iso).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}

export function dateTime(iso: string | null | undefined): string {
  if (!iso) return '–';
  return new Date(iso.includes('T') ? iso : iso.replace(' ', 'T')).toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function dayLabel(day: string, long = false): string {
  const d = new Date(`${day}T12:00:00`);
  return d.toLocaleDateString('fr-FR', long ? { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' } : { day: '2-digit', month: '2-digit' });
}

export function todayIso(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
